import debounceClick from "./debounceClick";
import preventReClick from "./preventReClick";
// 自定义指令
const directives = {
  debounceClick,
  preventReClick
};

export default {
  install(Vue) {
    Object.keys(directives).forEach(key => {
      Vue.directive(key, directives[key]);
    });
  }
};
